/**
 * ** Mews **
 *
 * @exports partnership_163
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};

  // Match the hostname of the URL to get the account_id for corporate scripts
  const corporateMappings = {
    'wombats-hostels': '76D74D751A8F1E95D8C5502AEE6FAB7F',
    clinkhostels: '5E3B133B67CD8FA98DDD053F700F7087',
    latroupe: '0597C68F68599EE40451E3F2BD9A34B6',
    polagiverola: '0597C68F68599EE40451E3F2BD9A34B6',
    mayanmonkey: 'DD88940932477594AE33EA6F3053DC0A',
    amsterdamcanalhotels: 'BE8660EF07F6573810F1A0ADA8031D85',
    lemarinhotels: 'BE8660EF07F6573810F1A0ADA8031D85',
  };

  const hotelMappings = {
    'hostel-grand-place': '6c7b71b7-b532-4b63-921d-ad17009d1dac',
    'hostel-la-granja': '01a64729-d2f9-42a9-8ec1-ad1200b9524c',
    'mayan-monkey-tulum': '8af33b23-2a9e-4b1e-93b8-ad1100a618be',
    'mayan-monkey-cancun': '21df2050-6b49-4239-aac3-ad11008a1cbc',
    'mayan-monkey-los-cabos': '14e7c5b7-b514-457b-9af8-ae3c00ec8214',
    'amsterdam-canal-hotel': 'e79f4352-5283-4e62-8f13-addb00976097',
    'grand-canal-boutique-hotel': 'b216ccf6-519a-45e4-b0ba-adce010036b6',
    'amsterdam-canal-suites': 'f850a136-a1db-4dbc-974b-adf800ab584e',
    'le-marin-boutique-hotel': '208cfc95-ab0e-4900-b87a-abf10099d4a8',
    'le-petit-marin-boutique-hotel': 'b5a3d9d0-f869-4203-8af4-acb001032ffa',
    'the-grazing-goat-marylebone': '99fc77b9-f385-4eee-96c6-af180082531a',
    'the-orange-pimlico': 'e966b439-8ef2-4302-90dd-af180082e5cf',
    'the-princess-royal-notting-hill': 'b060916f-7174-4203-a301-af1800817245',
    'latroupe-prado': '7daa340a-adbd-4330-b67a-af8e00fe9229',
    arosa: '33fb9623-abe1-43e2-b5c5-aec400e02665',
    'crans-montana': 'b3418f56-b50c-4c15-ad7a-aecc00e44e49',
    camping: '2050081e-e988-4e27-af3c-af8d00e71fe8',
    hotel: '116a937d-a536-403a-9f81-af8700919156', // PID 1043688, It should always be last because it is too generic. When adding other keys and values, they must be added before this one.
  };

  function getHotelLoaded() {
    return thn.dataLayerHelper.get('name');
  }

  function getDatalayerHotelId() {
    const dataLayer = window.dataLayer;
    return dataLayer && thn.objectGet(dataLayer, 'hotelId', { first: false });
  }

  /* la troupe hotel needs this verification because we are getting the hotelid from the datalayer, but
    in this particular case we can swicth the search of the hotels in the same page, the id in the datalayer
    only change once we make the search but if we come back to the home page it keeps the id from the datalayer
    with this verification we get the hotelid from the url of the hotel in case the home page is not the same
    of the search. */
  function getHotelHostname() {
    return Object.keys(hotelMappings).find((host) => window.location.pathname.match(new RegExp(host, 'i')))?.toString();
  }

  // By using the keys of corporate_mappings (hostnames) return hostname if we have a possible match
  // Returns empty string if no matches were found
  function getCorporateHostname() {
    return Object.keys(corporateMappings).filter((host) => window.location.hostname.match(new RegExp(host, 'i')))?.toString();
  }

  function isMewsOpened() {
    const iframe = Array.from(document.querySelectorAll('.mews-distributor')).pop();
    const isNotPropertiesLoaded = thn.dataLayerHelper.get('eventName') !== 'Properties Loaded';
    return !!(iframe && iframe.style.zIndex && iframe.style.zIndex >= 0) && isNotPropertiesLoaded;
  }

  /**
     * @memberOf module:partnership_163
     */
  partnership.getId = function getId() {
    return '163';
  };

  /**
     * @memberOf module:partnership_163
     */
  partnership.check = function check() {
    return getDatalayerHotelId() // BE
            || getHotelHostname() // be inside Corṕo
            || getCorporateHostname() // Corporate pages
            || getHotelLoaded();
  };

  /**
     * @memberOf module:partnership_163
     */
  partnership.getSiteId = function getSiteId() {

    const mewsHotelId = getDatalayerHotelId();

    const hotelHost = getHotelHostname();

    // Is a hotel, inside corporate?

    if (hotelHost?.length && (!isMewsOpened())) {
      return hotelMappings[hotelHost];
    }

    // Is a corporate case?
    // We are on the homepage or on the BE we are at a chain level (we see multiple properties)
    // Using the object keys of "corporate mappings" check if it matches with the hostname
    const coporateHost = getCorporateHostname();

    if (coporateHost?.length && (!isMewsOpened())) {
      return {
        accountKey: corporateMappings[coporateHost],
      };
    }

    // Check if the Mews BE is opened, if not, we should ignore the mews_hotel_id
    if (mewsHotelId && isMewsOpened()) {
      return mewsHotelId;
    }

    return '';
  };

  /**
     * @memberOf module:partnership_163
     */
  partnership.boot = function boot() {

    if (!window.dataLayer) {
      return;
    }

    partnership.shutdown = thn.generateCallbackQueue();

    const refreshPartnership = thn.debounce(thn.siteCheck, 800);
    // eslint-disable-next-line no-unused-vars
    let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
      if (((message.event === 'distributorAvailabilityLoaded' || message.eventName === 'Categories Loaded') && message.hotelId)
                || message.eventName === 'Properties Loaded'
                || message.event === 'distributorClosed'
                || message.event === 'distributorOpened') {
        refreshPartnership();
      }
    }, true);

    partnership.shutdown = function () {
      dataLayerHelper.unlisten();
      dataLayerHelper = null;
    };
  };

  return partnership;
}

export { factory };
